import React from 'react';
import { Form, Spinner } from 'react-bootstrap';

function GeneralSettings({ apiKey, setApiKey, model, setModel, modelsList, loadingModels, onApiKeyChange }) {
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Groq API Key</Form.Label>
        <Form.Control
          type="text"
          value={apiKey}
          onChange={(e) => {
            setApiKey(e.target.value);
            onApiKeyChange(e.target.value);
          }}
          placeholder="sk-...."
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Model Name</Form.Label>
        {loadingModels ? (
          <div className="d-flex align-items-center gap-2">
            <Spinner animation="border" size="sm" />
            <span>در حال بارگذاری مدل‌ها...</span>
          </div>
        ) : (
          <Form.Select
            value={model}
            onChange={(e) => setModel(e.target.value)}
          >
            <option value="">انتخاب مدل...</option>
            {modelsList.map((m, i) => (
              <option key={i} value={m}>
                {m}
              </option>
            ))}
          </Form.Select>
        )}
      </Form.Group>
    </>
  );
}

export default GeneralSettings;
